export default {
  prefix: '',
  suffix: '',
  thousands: ',',
  decimal: '.',
  precision: 2,
  allowBlank: false,
  min: Number.MIN_SAFE_INTEGER,
  max: Number.MAX_SAFE_INTEGER
}
